import classNames from 'classnames';
import React, {useState} from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import LegacyDropdownMenu from 'ui-library/dropdowns/LegacyDropdownMenu';
import LegacyDropdownMenuItem from 'ui-library/dropdowns/LegacyDropdownMenuConstants';
import SettingsIcon from 'ui-library/icons/SettingsIcon';

interface Props {
  options: Array<Array<LegacyDropdownMenuItem>>;
  dropdownClassName?: string;
  iconClassName?: string;
  onClick?: () => void;
  dropLeft?: boolean;
  disabled?: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export default function SettingsIconDropdown(props: Props): JSX.Element {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleOpenDropdown = (): void => {
    setIsDropdownOpen(true);
    if (props.onClick) {
      props.onClick();
    }
  };

  const handleCloseDropdown = (): void => {
    setIsDropdownOpen(false);
  };

  return (
    <AbsoluteDropdownContainer
      className={props.dropdownClassName}
      onRequestClose={handleCloseDropdown}
      open={isDropdownOpen}
      menu={<LegacyDropdownMenu items={props.options} dropLeft={props.dropLeft} />}
      shouldCloseOnInsideClick={true}
    >
      <SettingsIcon
        className={classNames(props.iconClassName, 'u-tiny-spacing-left')}
        onClick={props.disabled ? undefined : handleOpenDropdown}
        disabled={props.disabled}
        dataTestAttrs={props.dataTestAttrs}
      />
    </AbsoluteDropdownContainer>
  );
}
